import { useTheme } from '@mui/material';
import { ReactNode } from 'react';
import { CloseIcon, Heading4, TextL } from 'app/components';
import {
  ModalBody,
  ModalHeader,
  UploadCsvMessageModalContainer,
} from './styles';
import { BaseModal } from 'app/components';

export interface IUploadCsvMessageModal {
  isOpen: boolean;
  handleClose: () => void;
  title: string;
  icon: ReactNode;
  children: ReactNode;
}

const UploadCsvMessageModal = ({
  isOpen,
  handleClose,
  title,
  icon,
  children,
}: IUploadCsvMessageModal) => {
  const theme = useTheme();
  return (
    <BaseModal open={isOpen} onClose={handleClose}>
      <UploadCsvMessageModalContainer>
        <ModalHeader>
          <TextL>Importação de pessoas</TextL>
          <div onClick={handleClose}>
            <CloseIcon color={theme.palette.brand.secondary.base as string} />
          </div>
        </ModalHeader>
        <ModalBody>
          {icon}
          <Heading4
            style={{
              color: theme.palette.brand.secondary.base,
              marginTop: '24px',
              textAlign: 'center',
            }}
            fontWeight="B"
          >
            {title}
          </Heading4>
          <TextL
            style={{
              color: theme.palette.brand.secondary.base,
              textAlign: 'center',
            }}
          >
            {children}
          </TextL>
        </ModalBody>
      </UploadCsvMessageModalContainer>
    </BaseModal>
  );
};

export default UploadCsvMessageModal;
